import { Component, inject, input, output, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { contractDownloadName } from '@app/features/contracts/contract-file-name';
import { ContractService } from '@app/features/contracts/contract-service';
import { ContractListItem } from '@app/features/contracts/contract.model';
import { CdTDocument } from '@app/features/documents/document.model';
import { AsyncMatIconButton } from '@app/shared/buttons/async-mat-icon-button/async-mat-icon-button';
import moment from 'moment';
import { Observable } from 'rxjs';

/**
 * Télécharge la version imprimable d'un contrat.
 * L'affichage du PDF est laissé au parent via la sortie `documentReady`.
 */
@Component({
  selector: 'app-button-contract-pdf',
  imports: [MatIconModule, AsyncMatIconButton],
  templateUrl: './button-contract-pdf.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./button-contract-pdf.scss'],
})
export class ButtonContractPdf {
  contract = input.required<ContractListItem>();

  /** Émis avec le PDF généré, à afficher par le parent */
  documentReady = output<CdTDocument>();

  readonly contractService = inject(ContractService);

  get isAvailable(): boolean {
    const contract = this.contract();
    if (contract.deleted) {
      return false;
    }
    const status = contract.status;
    return status !== 'DRAFT' && status !== 'SIGNED' && status !== 'CANCELED';
  }

  getPdf(): Observable<Blob> {
    return this.contractService.getPdf(this.contract().id);
  }

  onPdfLoaded(blob: Blob): void {
    const contract = this.contract();
    const createdDate = moment().toISOString();
    this.documentReady.emit({
      id: '',
      tag: 'contract',
      name: this.contractService.getPdfName(
        contract.employeeFirstname ?? '',
        contract.employeeLastname ?? '',
        createdDate,
      ),
      // Affiché sous le nom de toutes les pièces, téléchargé sous celui du disque réseau
      // (RG-contrat-nom-de-telechargement).
      downloadName: contractDownloadName(contract),
      mimeType: 'application/pdf',
      createdAt: createdDate,
      size: blob.size,
      blob: new Blob([blob], { type: 'application/pdf' }),
    });
  }
}
